










































































































































































import { Component, Inject, Vue } from 'vue-property-decorator'
import { RealworksAPI } from '@/api/client/realworks'
import { MedewerkerWithUser, Relatie } from '@/api/realworks-types'
import { Branch } from '@/api/model/branch'
import { User } from '@/api/model/user'
import { RealworksCredentials } from '@/api/model/credentials'
import { availableRoles, CredentialsType } from '@/api/types'

@Component
export default class CompanySettingsUsersCreateFromRealworks extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    loading: boolean = true
    medewerkers: MedewerkerWithUser[] = []
    medewerkersMapping: {[key: string]: { role: string, branches: Branch[]}} = {}
    informUsers: boolean = false
    creating: boolean = false

    async mounted() {
        this.loading = true

        if (this.realworksConfigured) {
            await this.importMedewerkers()
            await this.loadMedewerkers()
            this.initMedewerkersMapping()
        }

        this.loading = false
    }

    get realworksConfigured(): boolean {
        const credentials = this.$currentCompany.getCredentialsWithType(CredentialsType.REALWORKS) as RealworksCredentials[]

        return credentials.length > 0
    }

    async importMedewerkers() {
        await RealworksAPI.importMedewerkers(this.$currentCompany)
    }

    async loadMedewerkers() {
        this.medewerkers = await RealworksAPI.getMedewerkersWithUser()
        this.medewerkers.sort((a, b) => {
            return this.medewerkerNaam(a.medewerker).localeCompare(this.medewerkerNaam(b.medewerker))
        })
    }

    initMedewerkersMapping() {
        this.medewerkers.forEach(medewerker => {
            this.$set(this.medewerkersMapping, medewerker.medewerker.id, {
                role: null,
                branches: [],
            })
        })
    }

    async createUsers(validate) {
        const valid = await validate()
        if (!valid) {
            this.$notify({
                group: 'validation',
                type: 'warn',
                title: this.$t('company_settings.users.create_from_realworks.validation_error.title').toString(),
                text: this.$t('company_settings.users.create_from_realworks.validation_error.text').toString().replace(/\n/g, '<br>'),
            })
            return
        }

        try {
            this.creating = true

            await RealworksAPI.createUsersForMedewerkers(this.medewerkersMapping, this.informUsers)
            this.$notify({
                group: 'information',
                type: 'success',
                title: this.$t('company_settings.users.create_from_realworks.success.title').toString(),
                text: this.$t('company_settings.users.create_from_realworks.success.message').toString(),
            })
            await this.reloadCompany()
        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: error.message,
            })
        } finally {
            this.creating = false
        }
    }

    get medewerkersWithoutUser(): MedewerkerWithUser[] {
        return this.medewerkers
            .filter(medewerker => medewerker.user === null && medewerker.medewerker.emailadressen.length > 0)
    }

    get medewerkersWithUser(): MedewerkerWithUser[] {
        return this.medewerkers
            .filter(medewerker => medewerker.user !== null)
    }

    get mappedMedewerkers(): MedewerkerWithUser[] {
        return this.medewerkers
            .filter(medewerker => this.getMappedRole(medewerker.medewerker) !== null)
    }

    getMappedRole(medewerker: Relatie): string|null {
        return this.medewerkersMapping[medewerker.id].role
    }

    setMappedRole(medewerker: Relatie, role: string|null): void {
        this.medewerkersMapping[medewerker.id].role = role
    }

    getMappedBranches(medewerker: Relatie): Branch[] {
        return this.medewerkersMapping[medewerker.id].branches
    }

    setMappedBranches(medewerker: Relatie, branches: Branch[]): void {
        this.medewerkersMapping[medewerker.id].branches = branches
    }

    medewerkerNaam(medewerker: Relatie): string {
        let voornaam = medewerker.roepnaam
        if (!voornaam) {
            voornaam = (medewerker.titel + ' ' + medewerker.initialen).trim()
        }

        return [voornaam, medewerker.tussenvoegsel, medewerker.achternaam]
            .filter(value => value !== null && value !== '')
            .join(' ')
    }

    medewerkerBranches(user: User): any[] {
        return Object.values(user.keyVueBranches).sort((a: any, b: any) => {
            return a.name.localeCompare(b.name)
        })
    }

    get roleOptions() {
        return availableRoles().map(value => ({
            label: this.$t(`role.${value}`),
            value,
        }))
    }

    get availableBranches() {
        return this.$currentCompany.getAvailableBranches()
    }
}
